// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__qqsy_","title":"style_title__nmX2p","icon":"style_icon__DWWL2","unread":"style_unread__3bwwD","spin":"style_spin__Mq5AO"};